var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 195,
    viewBox: "0 0 248 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 195,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.166 102.247L113.209 95.2906L108.791 99.7094L120.584 111.503L138.403 90.1281L133.597 86.1219L120.166 102.247Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.375 69.375H101.625C98.1781 69.375 95.375 72.1781 95.375 75.625V119.375C95.375 122.822 98.1781 125.625 101.625 125.625H145.375C148.822 125.625 151.625 122.822 151.625 119.375V75.625C151.625 72.1781 148.822 69.375 145.375 69.375ZM101.625 119.375V75.625H145.375L145.381 119.375H101.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.ad97f793c39038c960167e50c1b34bc5.svg";
export { ForwardRef as ReactComponent };